import React, { useState, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupTCU.css';
import ModalConfirmacion from '../../SolarFarm/Comandos/ModalConfirmacion';
import ModalPersonalizado from '../../SolarFarm/Comandos/ModalPersonalizado';
import { GiWindsock,GiBroom, GiHand} from 'react-icons/gi';
import { Modal } from 'react-bootstrap';
import {BsSnow3, BsArrowCounterclockwise} from 'react-icons/bs';
import {FaChartPie} from 'react-icons/fa';
import {MdOutlineMotionPhotosAuto} from 'react-icons/md';
import {TbLetterA} from 'react-icons/tb';
import { icon } from 'leaflet';

const PopupTCU = (props) => {
    var comandos = (JSON.parse(sessionStorage.getItem("commands")));
    const {id,idCT,idInverter,idTracker,name, status, color, position, positionTarget, alarms } = props;

    var link = "/#/inv/" + idCT + "/" + idInverter;
    var colorAux;
    color === '#ffffff' ? colorAux = '#000000' : colorAux = color;
    var size_ico = 20; 

    var [enviarLista, setEnviarLista] = useState('');
    var [enviarDevice, setEnviarDevice] = useState();
    const [abrirModal, setAbrirModal] = useState(false);
    const [abrirModalPers, setAbrirModalPers] = useState(false)
    var [comandoEnviado, setComandoEnviado] = useState('');

    //Comandos
    const [displayTCU,setDisplayTCU] = useState('none');//Si hay por TCU individual
    const [displayTCUWind,setDisplayTCUWind] = useState('none');
    const [displayTCUSnow,setDisplayTCUSnow] = useState('none');
    const [displayTCUClean,setDisplayTCUClean] = useState('none');
    const [displayTCUPerso,setDisplayTCUPerso] = useState('none');
    const [displayTCUReset,setDisplayTCUReset] = useState('none');
    const [displayTCUResetAlarm,setDisplayTCUResetAlarm] = useState('none');
    const [displayTCUAuto,setDisplayTCUAuto] = useState('none');
    const [displayTCUManual,setDisplayTCUManual] = useState('none');
    const [htmlBotones, setHtmlBotones] = useState(<></>);

    const childToParent = (abrirModal) => {
        setAbrirModal(abrirModal)
    }
    const childToParentPers = (abrirModalPers) => {
        setAbrirModalPers(abrirModalPers)
    }

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "Inverter");
    const [hrefDisabled,setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === false){
            setHrefDisabled(<a className='a-ver-tcu' style={{cursor:'none'}}>{name}</a> )
        }else{
            setHrefDisabled(<a className='a-ver-tcu' href={link}>{name}</a>)
        }
    },[]);

    useEffect(() => {
        for(let i = 0;i<comandos.length;i++) {

            switch(comandos[i].IdDevice){
                case 3://Tracker
                    if(displayTCU === 'none'){//Para que no haga por cada comando 
                        setDisplayTCU(''); //un set de este display
                    }
                    switch(comandos[i].Command){
                        case 'WIND':
                            if(displayTCUWind === 'none'){
                                setDisplayTCUWind('');
                            }
                        break;
                        case 'SNOW':
                            if(displayTCUSnow ==='none'){
                                setDisplayTCUSnow('');
                            }
                        break;
                        case 'CLEAN':
                            if(displayTCUClean === 'none'){
                                setDisplayTCUClean('');
                            }
                        break;
                        case 'PERSO':
                            if(displayTCUPerso ==='none'){
                                setDisplayTCUPerso('');
                            }
                        break;
                        case 'RESET':
                            if(displayTCUReset === 'none'){
                                setDisplayTCUReset('');
                            }
                        break;
                        case 'RESET_ALARM':
                            if(displayTCUResetAlarm ==='none'){
                                setDisplayTCUResetAlarm('');
                            }
                        break;
                        case 'AUTO':
                            if(displayTCUAuto === 'none'){
                                setDisplayTCUAuto('');
                            }
                        break;
                        case 'MANUAL':
                            if(displayTCUManual ==='none'){
                                setDisplayTCUManual('');
                            }
                        break;
                        default:
                    }
                break;
                default:
            
            }
        }
    },[]);





    useEffect(()=>{
        var botones =<>
                <div className='row mt-4' style={{display:displayTCU}}>
                    <div className='col' style={{textAlign: 'center'}}>
                        <h6><strong>Comandos</strong></h6>
                    </div>
                </div>
                <div className='row' style={{justifyContent: 'center', display:displayTCU}}>
                    <div className='col-sm tcu-button-command' style={{width: 'fit-content',margin: '0px', padding: '0px', display:displayTCUWind}}>
                        <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('WIND'); setEnviarDevice(3); setEnviarLista(id) }}>
                            <GiWindsock size={size_ico} title={"Posición Viento"} color={"white"}/>
                        </a>
                    </div>
                    <div className='col-sm tcu-button-command'  style={{width: 'fit-content',margin: '0px', padding: '0px', display: displayTCUSnow}}>
                        <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('SNOW'); setEnviarDevice(3); setEnviarLista(id) }}>
                            <BsSnow3 size={size_ico} title={"Posición Nieve"} color={"white"}/>
                        </a>
                    </div>
                    <div className='col-sm tcu-button-command'  style={{width: 'fit-content',margin: '0px', padding: '0px', display:displayTCUClean}}>
                        <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('CLEAN'); setEnviarDevice(3); setEnviarLista(id) }}>
                            <GiBroom size={size_ico} title={"Posición Limpieza"} color={"white"}/>
                        </a>
                    </div>
                    <div className='col-sm tcu-button-command'  style={{width: 'fit-content',margin: '0px', padding: '0px', display:displayTCUPerso}}>
                        <a className='a-tcu-command-icon' onClick={() => { setAbrirModalPers(true); setComandoEnviado('PERSO'); setEnviarDevice(3); setEnviarLista(id) }}>
                            <FaChartPie size={size_ico} title={"Posición Personalizada"} color={"white"}/>
                        </a>
                    </div>
                    <div className='col-sm tcu-button-command'  style={{width: 'fit-content',margin: '0px', padding: '0px', display: displayTCUReset}}>
                        <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('RESET'); setEnviarDevice(3); setEnviarLista(id) }}>
                            <BsArrowCounterclockwise size={size_ico} title={"Reset"} color={"white"}/>
                        </a>
                    </div>
            </div>
            <div className='row justify-content-md-center mt-3' style={{display:displayTCU}}>
                <div className='col-auto tcu-button-command'  style={{margin: '0px', padding: '0px', display:displayTCUAuto}}>
                    <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('AUTO'); setEnviarDevice(3); setEnviarLista(id) }}>
                        <TbLetterA size={size_ico} title={"Automático"} color={"white"}/>
                    </a>
                </div>
                <div className='col-auto tcu-button-command'  style={{margin: '0px', padding: '0px', display: displayTCUManual}}>
                    <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('MANUAL'); setEnviarDevice(3); setEnviarLista(id) }}>
                        <GiHand size={size_ico} title={"Manual"} color={"white"}/>
                    </a>
                </div>
                <div className='col-auto tcu-button-command'  style={{margin: '0px', padding: '0px', display:displayTCUResetAlarm}}>
                    <a className='a-tcu-command-icon' onClick={() => { setAbrirModal(true); setComandoEnviado('RESET_ALARM'); setEnviarDevice(3); setEnviarLista(id) }}>
                        <MdOutlineMotionPhotosAuto size={size_ico} title={"Reset Alarmas"} color={"white"}/>
                    </a>
                </div> 
            </div>     
        </>

            setHtmlBotones(botones);
    },[displayTCU, displayTCUAuto, displayTCUClean, displayTCUManual, displayTCUPerso, displayTCUReset, displayTCUResetAlarm, displayTCUSnow, displayTCUWind])





    return (
        <div className='container-fluid' style={{width: 'fit-content', padding: '0px'}}>
            <div className='row justify-content-center mb-3'>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row texto-tcu-popup'>
                <div className='col'>Estado: <strong style={{color: colorAux}}>{status}</strong></div>
            </div>
            {alarms.length !== 0 ?
            <div className='row texto-tcu-popup'>
                <div className='col'>Alarmas activas: <strong>{alarms}</strong></div>
            </div> : <></>}
            <div className='row texto-tcu-popup'>
                <div className='col-auto'>Orientación: <strong>{position}º</strong></div>
            </div>
            <div className='row texto-tcu-popup'>
                <div className='col-auto'>Orientación objetivo: <strong>{positionTarget}º</strong></div>
            </div>
            
            {htmlBotones}        
            <Modal centered show={abrirModal} onHide={() => setAbrirModal(false)} aria-labelledby="reset_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConfirmacion comando={comandoEnviado} dispositivo={enviarDevice} cerrarModal={childToParent} ids={enviarLista} />
                </Modal.Body>
            </Modal>
            <Modal centered show={abrirModalPers} onHide={() => setAbrirModalPers(false)} aria-labelledby="reset_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Grados manuales</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalPersonalizado comando={comandoEnviado} dispositivo={enviarDevice} cerrarModal={childToParentPers} ids={enviarLista} />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default PopupTCU;